import { Button } from 'ui';

import { getSiteMaterialUrl } from '../../utils/getSiteMaterialUrl';

export const ViewManageButton = ({ siteMaterialId }: { siteMaterialId: number }) => {
  return (
    <Button component="a" href={getSiteMaterialUrl(siteMaterialId)}>
      View / Manage
    </Button>
  );
};
